import { InstitutionCheckExceptionReturnReasonDto } from '@treasury/api/channel';
import { DomainEntity } from '../../../../shared';

const defaultInstitutionCheckExceptionReturnReasonDto: InstitutionCheckExceptionReturnReasonDto = {
    isDefault: false,
    returnReasonUniqueId: '',
    isDeleted: false,
};

export class CheckExceptionReturnReason extends DomainEntity<InstitutionCheckExceptionReturnReasonDto> {
    public createDefault(): this {
        return new CheckExceptionReturnReason(
            defaultInstitutionCheckExceptionReturnReasonDto
        ) as this;
    }

    public get returnReasonUniqueId() {
        return this.dto.returnReasonUniqueId;
    }

    public get description() {
        return this.dto.description;
    }

    public get isDefault() {
        return this.dto.isDefault;
    }

    public get isDeleted() {
        return this.dto.isDeleted;
    }
}
